import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  private isCollapsed = signal<boolean>(false);
  private selectedMenu = signal<string>("");

  readonly isCollapsed$ = this.isCollapsed.asReadonly();
  readonly menu$ = this.selectedMenu.asReadonly();

  toggleSidebar() {
    this.isCollapsed.update(state => !state);
  }

  setSidebarState(state: boolean) {
    this.isCollapsed.set(state);
  }

  setMenu(activeMenu: string) {
    this.selectedMenu.set(activeMenu);
  }
}
